module.exports = __webpack_public_path__ + "static/media/md-albums.f301f66f.svg";